// extracted by css-extract-rspack-plugin
export default {"vertical":"vertical-1zUFD"};